export default __webpack_public_path__ + "static/media/Raleway-SemiBold.cc770b2a.ttf";